import { Pipe, PipeTransform } from '@angular/core';
import { ProductVariant } from '@greco/sales-products';

@Pipe({ name: 'getVariant' })
export class GetVariantPipe implements PipeTransform {
  transform(variantId: string, variants: ProductVariant[]) {
    return variants.find(variant => variant.id === variantId);
  }
}
